import { makeStyles } from "@material-ui/core/styles";
import { colors, greys } from "@clockwise/web-commons/src/styles/color.styles";

export const useStyles = makeStyles({
  header: {
    marginTop: 5,
    display: "flex",
    alignItems: "center",
    padding: "6px 16px",
    minHeight: 60,
    "& > div": {
      margin: "4px 0",
      padding: "0 0 0 12px",
    },
  },
  sidebar: {
    width: "100%",
    maxWidth: 270,
    background: greys.palePaleGrey,
    borderRight: `1px solid ${greys.borderGrey}`,
    flexShrink: 0,
    whiteSpace: "nowrap",
    "& > * > :first-child": {
      marginTop: 20,
    },
  },
  paper: {
    top: 80,
    position: "static",
  },
  toolbar: {
    marginTop: 10,
    padding: "0px 5px",
    "& > *": {
      display: "flex",
    },
  },
  sidebar__open: {
    width: "100%",
    maxWidth: 270,
    transition: "max-width ease-in-out .35s",
  },
  sidebar__closed: {
    width: "100%",
    maxWidth: 60,
    transition: "max-width ease-in-out .35s",
    overflowX: "hidden",
  },
  menuItem: {
    minHeight: 60,
    lineHeight: "18px",
    "& .MuiListItemText-primary": {
      fontSize: 16,
    },
  },
  menuItemIcon: {
    "& > svg": {
      fill: greys.standard,
    },
  },
  menuItem__active: {
    background: greys.borderGrey,
  },
  menuActionIcon: {
    color: colors.blueDusk.standard,
  },
  menuActionIcon__left: {
    transform: "rotate(180deg)",
  },
});
